module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "App",
    class: _vm.themeClass,
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "App-"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5320eac2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 281
// module chunks = 1